import { useUpdateKeyPerson } from '@commenda/api';
import { useNotification } from '../../../hooks/useNotification';
import { DeleteConfirmationModal } from '../../../molecules/modals/ConfirmationModal';

export const RemoveCustomFieldModal = ({
  isOpen,
  onClose,
  keyPersonId,
  companyId,
  fieldKey,
  fieldLabel,
}: {
  isOpen: boolean;
  onClose: () => void;
  keyPersonId: number;
  companyId: number;
  fieldKey: string | null;
  fieldLabel?: string;
}) => {
  const { setNotification } = useNotification();
  const { mutateAsync: updateKeyPerson } = useUpdateKeyPerson(
    keyPersonId,
    companyId
  );

  const handleConfirm = async () => {
    if (!fieldKey) return;
    try {
      await updateKeyPerson({ customFields: { [fieldKey]: null } });
      setNotification({
        show: true,
        title: 'Custom field removed',
        message: 'The custom field has been removed.',
        valid: true,
      });
    } catch (error) {
      setNotification({
        show: true,
        title: 'Failed to remove custom field',
        message: error instanceof Error ? error.message : 'Please try again.',
        valid: false,
      });
      // Re-throw so the modal stays open on failure (it auto-closes on a resolved confirm).
      throw error;
    }
  };

  return (
    <DeleteConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      title="Remove custom field?"
      message={`This removes "${fieldLabel ?? 'this field'}" from this key person. A saved-for-future field stays available on the workspace — this only clears it here. This action cannot be undone.`}
      confirmButtonText="Remove"
    />
  );
};
